var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanProGoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500244,
    y: 1.36755,
    width: 55,
    height: 55,
    rx: 1.5,
    fill: "url(#paint0_linear_66_10716)",
    stroke: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_66_10716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 57
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    y: 0.867554,
    width: 56,
    height: 56,
    rx: 2,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_66_10716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31778 -1.20002C4.74342 -7.34292 6.45488 -10.4144 9.01533 -10.4144C11.5758 -10.4144 13.2872 -7.34292 16.7129 -1.20002L17.5997 0.389776C18.573 2.13639 19.0597 3.0097 19.8168 3.5856C20.5738 4.16149 21.5201 4.37509 23.4127 4.80228L25.1323 5.19162C31.7835 6.6976 35.1064 7.44924 35.8986 9.99346C36.6881 12.535 34.4224 15.1873 29.8882 20.4894L28.7148 21.8602C27.4278 23.3662 26.7816 24.1205 26.4923 25.0506C26.203 25.9834 26.3003 26.9892 26.495 28.998L26.6734 30.8285C27.3575 37.9042 27.7009 41.4407 25.6298 43.0115C23.5587 44.5851 20.444 43.1494 14.22 40.2835L12.6059 39.5426C10.8376 38.7261 9.95352 38.3205 9.01533 38.3205C8.07713 38.3205 7.193 38.7261 5.42205 39.5426L3.81333 40.2835C-2.41338 43.1494 -5.52809 44.5824 -7.59645 43.0142C-9.67022 41.4407 -9.32684 37.9042 -8.6428 30.8285L-8.46435 29.0007C-8.26968 26.9892 -8.17235 25.9834 -8.46435 25.0533C-8.75095 24.1205 -9.39714 23.3662 -10.6841 21.8629L-11.8575 20.4894C-16.3917 15.19 -18.6574 12.5377 -17.868 9.99346C-17.0758 7.44924 -13.7502 6.6949 -7.09896 5.19162L-5.37938 4.80228C-3.48947 4.37509 -2.54586 4.16149 -1.78611 3.5856C-1.02907 3.0097 -0.542393 2.13639 0.430953 0.389776L1.31778 -1.20002Z",
    stroke: "#D83F3F",
    strokeWidth: 1.5,
    style: {
      mixBlendMode: "color-burn"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8902 17.0357L22.8938 17.0293C25.1655 12.9556 26.3013 10.9188 28.0002 10.9188C29.699 10.9188 30.8349 12.9557 33.1066 17.0293L33.1102 17.0357L33.6989 18.0911C34.345 19.2506 34.6681 19.8304 35.1707 20.2127C35.6732 20.595 36.3014 20.7368 37.5579 21.0204L38.6994 21.2788L38.7035 21.2798C43.1162 22.2789 45.3208 22.7781 45.8466 24.4665C46.3707 26.1537 44.8666 27.9145 41.8566 31.4342L41.0776 32.3442L41.0698 32.3533C40.2206 33.347 39.7937 33.8466 39.6022 34.4622C39.4102 35.0814 39.4748 35.7491 39.604 37.0827L39.7225 38.2978L39.7234 38.3072C40.1769 42.9981 40.4036 45.3434 39.0296 46.3855C37.6556 47.4295 35.5895 46.4781 31.4625 44.5778L31.4553 44.5745L30.3838 44.0827C29.2099 43.5406 28.623 43.2714 28.0002 43.2714C27.3773 43.2714 26.7904 43.5406 25.6148 44.0827L24.5468 44.5745C20.4132 46.477 18.3455 47.4283 16.9725 46.3873C15.5967 45.3434 15.8235 42.9981 16.277 38.3072L16.2779 38.2978L16.3963 37.0845C16.5255 35.7491 16.5902 35.0814 16.3963 34.464C16.2062 33.8452 15.7777 33.3447 14.9247 32.3483L14.9227 32.346L14.1438 31.4342C11.1338 27.9163 9.62965 26.1555 10.1538 24.4665C10.6797 22.7775 12.8873 22.2768 17.3027 21.2788L18.4443 21.0204C19.6989 20.7368 20.3253 20.595 20.8297 20.2127C21.3322 19.8304 21.6553 19.2506 22.3014 18.0911L22.8902 17.0357Z",
    fill: "url(#paint1_linear_66_10716)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_10716",
    x1: 28.0002,
    y1: 0.867554,
    x2: 28.0002,
    y2: 56.8676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.604291,
    stopColor: "#FFF2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9DDA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_10716",
    x1: 34.5445,
    y1: 19.3263,
    x2: 28.0002,
    y2: 46.8161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185587,
    stopColor: "#F3CF4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDAE65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanProGoldIcon);
export default __webpack_public_path__ + "static/media/PlanProGoldIcon.cdfbf9045e9f8f2979f5e965d20078b4.svg";
export { ForwardRef as ReactComponent };